import { Animation, createAnimation } from '@ionic/angular';

/** Entrada do painel lateral: desliza da direita e escurece o fundo. */
export const sideSheetEnter = (baseEl: HTMLElement): Animation => {
  const root = baseEl.shadowRoot as ShadowRoot;
  const wrapper = root.querySelector('.modal-wrapper') as HTMLElement;
  const backdrop = root.querySelector('ion-backdrop') as HTMLElement;
  return createAnimation()
    .addElement(baseEl)
    .easing('ease-out')
    .duration(260)
    .addAnimation([
      createAnimation().addElement(backdrop).fromTo('opacity', '0', 'var(--backdrop-opacity)'),
      createAnimation().addElement(wrapper).fromTo('transform', 'translateX(100%)', 'translateX(0)').fromTo('opacity', '0.01', '1'),
    ]);
};

/** Saída do painel lateral: volta para a direita e clareia o fundo. */
export const sideSheetLeave = (baseEl: HTMLElement): Animation => {
  const root = baseEl.shadowRoot as ShadowRoot;
  const wrapper = root.querySelector('.modal-wrapper') as HTMLElement;
  const backdrop = root.querySelector('ion-backdrop') as HTMLElement;
  return createAnimation()
    .addElement(baseEl)
    .easing('ease-in')
    .duration(220)
    .addAnimation([
      createAnimation().addElement(backdrop).fromTo('opacity', 'var(--backdrop-opacity)', '0'),
      createAnimation().addElement(wrapper).fromTo('transform', 'translateX(0)', 'translateX(100%)').fromTo('opacity', '1', '0.01'),
    ]);
};
